export const useAuth = () => {
  //const runtimeConfig = useRuntimeConfig()
  const appConfigStore = useAppConfigStore()
  const appConfig = appConfigStore.appConfig!
  const accessToken = useCookie(appConfig.public.CLIENT_ACCESS_TOKEN_COOKIE)
  const userDataCookie = useCookie(appConfig.public.CLIENT_USER_COOKIE)
  const { $axios } = useNuxtApp()
  const { setUserData, clearUserData } = useUserStore()

  const login = async (username: string, password: string, isAdmin: boolean) => {
    const res = await $axios.post(
      isAdmin ? useApi().adminAuthApi.LOGIN : useApi().authApi.LOGIN,
      { customerCode: username, password, type: isAdmin ? 'A' : 'U' },
      {
        withCredentials: true
      }
    )
    accessToken.value = res.data.accessToken

    delete res.data.accessToken
    delete res.data.refreshToken
    userDataCookie.value = res.data
    setUserData(userDataCookie.value)
  }

  const refresh = async () => {
    const res = await $axios.post(
      useApi().authApi.REFRESH,
      {},
      {
        withCredentials: true
      }
    )
    accessToken.value = res.data.accessToken
    await refreshNuxtData()
  }

  const logout = async () => {
    await $axios.post(
      useApi().authApi.LOGOUT,
      {},
      {
        withCredentials: true
      }
    )
    clearUserData()
    accessToken.value = null
    userDataCookie.value = null
  }

  const checkUserVerification = async (resetToken: string) => {
    await $axios.get(useApi().authApi.VERIFICATION, {
      params: {
        token: resetToken
      }
    })
  }
  const resetPassword = async (bodyObj: object) => {
    await $axios.put(useApi().authApi.RESETPASSWORD, bodyObj)
  }

  return { accessToken, login, logout, refresh, checkUserVerification, resetPassword }
}
